import { useEffect, useState } from "react";

import { isApiClientError } from "../api/errors";

export const authRateLimitMessage =
  "Слишком много попыток. Подождите минуту и повторите.";

export function authRetryDelay(value: string | null, now = Date.now()): number {
  if (value !== null && /^\d+$/.test(value.trim())) {
    const seconds = Number(value);
    if (Number.isSafeInteger(seconds)) return seconds * 1000;
  }
  if (value !== null) {
    const deadline = Date.parse(value);
    if (Number.isFinite(deadline)) return Math.max(0, deadline - now);
  }
  return 60_000;
}

export function useAuthRateLimit() {
  const [deadline, setDeadline] = useState<number | null>(null);
  useEffect(() => {
    if (deadline === null) return;
    // Большие Retry-After не должны переполнять 32-битный таймер браузера.
    let timer: number;
    const schedule = () => {
      const remaining = deadline - Date.now();
      if (remaining <= 0) setDeadline(null);
      else
        timer = window.setTimeout(schedule, Math.min(remaining, 2_147_483_647));
    };
    schedule();
    return () => window.clearTimeout(timer);
  }, [deadline]);

  return {
    blocked: deadline !== null && deadline > Date.now(),
    handleError(error: unknown): boolean {
      if (!isApiClientError(error) || error.status !== 429) return false;
      setDeadline(
        Date.now() + authRetryDelay(error.responseHeaders.retryAfter),
      );
      return true;
    },
  };
}
